import { useCallback, useEffect } from 'react';
import { useWidgetScopeContext } from '../../../../../../form/fillable/WidgetScopeContext';
import { useRepeatableListEditor } from '../../../repeat-controller/useRepeatableListEditor';
import { IButtonActionListRemove } from '../IButtonAction';
import { IButtonActionLogicComponentProps } from '../common/IButtonActionLogicComponentProps';

export function ButtonActionListRemoveLogicComponent(
  props: IButtonActionLogicComponentProps<IButtonActionListRemove>,
) {
  const { action, buttonWidgetOptions, onClickSubject } = props;

  const { listIndex } = useWidgetScopeContext();

  const { handleRemove } = useRepeatableListEditor(
    buttonWidgetOptions.name,
    action.listReference,
  );

  const handleAction = useCallback(() => {
    if (!action.listReference) {
      console.warn(`ListAddActionComponent: listReference is not defined`);
      return;
    }

    if (listIndex == null) {
      console.warn(`ListAddActionComponent: listIndex is not defined`);
      return;
    }

    handleRemove(listIndex);
  }, [action.listReference, handleRemove, listIndex]);

  useEffect(() => {
    const subscription = onClickSubject.subscribe(handleAction);
    return () => subscription.unsubscribe();
  }, [onClickSubject, handleAction]);

  return null;
}
